var $ = require('jquery');

$('.js-content-promo__play').click( function(e){
	e.preventDefault();

	$(this).parents('.content-promo__media').addClass('content-promo__media--view-video');

	// Autoplay the youtube video in the iframe when the modal opens.
	var iframe = $(this).siblings('.iframe-container').children('iframe');
		// console.log('iframe = ');
		// console.log(iframe);
	var iframe_src = iframe[0].getAttribute('src');
		// console.log('iframe_src = ');
		// console.log(iframe_src);
	if( !iframe_src ){
		iframe_src = $(iframe[0]).data('src');
		// console.log('iframe_src = ');
		// console.log(iframe_src);
	}
	var autoplay_string = iframe_src.indexOf('autoplay');
		// console.log('autoplay_string = ');
		// console.log(autoplay_string);

	if( autoplay_string >= 0 ){
		iframe[0].setAttribute('src', iframe_src.replace('autoplay=0', 'autoplay=1') );

	} else {

		if( iframe_src.indexOf('?') >= 0 ){
			iframe[0].setAttribute( 'src', iframe_src+'&autoplay=1' );

		} else {
			iframe[0].setAttribute( 'src', iframe_src+'?autoplay=1' );
		}

	}

});
